import { defineCustomElement } from '@tyler-components-web/core';
import { OmnibarMenuButtonComponent } from './omnibar-menu-button';
export * from './omnibar-menu-button-constants';
export * from './omnibar-menu-button';
export function defineOmnibarMenuButtonComponent() {
    defineCustomElement(OmnibarMenuButtonComponent);
}
